/*jshint eqeqeq:false, eqnull:true*/
SAPO.namespace('Dom');

/**
 * @namespace SAPO.Dom.Event
 *
 */
SAPO.Dom.Event = {

    KEY_BACKSPACE: 8,
    KEY_TAB:       9,
    KEY_RETURN:   13,
    KEY_ESC:      27,
    KEY_LEFT:     37,
    KEY_UP:       38,
    KEY_RIGHT:    39,
    KEY_DOWN:     40,
    KEY_DELETE:   46,
    KEY_HOME:     36,
    KEY_END:      35,
    KEY_PAGEUP:   33,
    KEY_PAGEDOWN: 34,
    KEY_INSERT:   45,


    /**
     * @function {Node} ? - Returns the target of the event object
     * @param {Object} ev - event object
     * @return The target
     */
    element: function(ev)
    {
        var node = ev.target ||
            // IE stuff
            (ev.type == 'mouseout'   && ev.fromElement) ||
            (ev.type == 'mouseleave' && ev.fromElement) ||
            (ev.type == 'mouseover'  && ev.toElement) ||
            (ev.type == 'mouseenter' && ev.toElement) ||
            ev.srcElement ||
            null;
        return node && (node.nodeType == 3 || node.nodeType == 4) ? node.parentNode : node;
    },

    /**
     * @function ? Attach an event to element
     * @param {DOMElement|String} element - element id or element
     * @param {String} eventName - event name
     * @param {Function} callBack - Receives event object as a
     * parameter. If you're manually firing custom events, check the
     * eventName property of the event object to make sure you're handling
     * the right event.
     * @param {Boolean} useCapture - set to true to change event listening from bubbling to capture.
     */
    observe: function(element, eventName, callBack, useCapture)
    {
        element = s$(element);
        if(element !== null && element !== undefined) {
            if(eventName.indexOf(':') !== -1 ||
                (eventName === "hashchange" && element.attachEvent && !window.onhashchange)
                ) {

                /**
                 *
                 * prevent that each custom event fire without any test
                 * This prevents that if you have multiple custom events
                 * on dataavailable to trigger the callback event if it
                 * is a different custom event
                 *
                 */
                var argCallback = callBack;
                callBack = function(ev, eventName, cb){

                  //tests if it is our event and if not
                  //check if it is IE and our dom:loaded was overrided (IE only supports one ondatavailable)
                  //- fix /opera also supports attachEvent and was firing two events
                  if(ev.eventName === eventName || (SAPO.Browser.IE && eventName === 'dom:loaded')){
                    //fix for FF since it loses the event in case of using a second binObjEvent
                    if(window.addEventListener){
                      window.event = ev;
                    }
                    cb();
                  }

                }.bindObjEvent(this, eventName, argCallback);

                eventName = 'dataavailable';
            }






            if(element.addEventListener) {
                element.addEventListener(eventName, callBack, !!useCapture);
            } else {
                element.attachEvent('on' + eventName, callBack);
            }
        }
    },

    /**
     * @function ? Remove an event attached to an element
     * @param {DOMElement|String} element - element id or element
     * @param {String} eventName - event name
     * @param {Function} callBack - callback function
     * @param {Boolean} useCapture - set to true if the event was being observed with useCapture set to true as well.
     */
    stopObserving: function(element, eventName, callBack, useCapture)
    {
        element = s$(element);

        if(element !== null && element !== undefined) {
            if(element.removeEventListener) {
                element.removeEventListener(eventName, callBack, !!useCapture);
            } else {
                element.detachEvent('on' + eventName, callBack);
            }
        }
    },

    /**
     * @function ? stops event propagation and bubbling
     * @param {Object} event - event handle
     */
    stop: function(event) {
        if (!event) {
            return;
        }

        if(event.cancelBubble !== null) {
            event.cancelBubble = true;
        }
        if(event.stopPropagation) {
            event.stopPropagation();
        }

        if(event.preventDefault) {
            event.preventDefault();
        }
        if(window.attachEvent) {
            event.returnValue = false;
        }
        if(event.cancel !== null) {
            event.cancel = true;
        }
    },

    /**
     * @function {Object} ?
     * @param {Object} ev - event object
     * @return an object with the mouse X and Y position
     */
    pointer: function(ev)
    {
        if ('changedTouches' in ev) {
            var ct = ev.changedTouches[0];
            return {
                x: ct.pageX,
                y: ct.pageY
            };
        }

        return {
                x: ev.pageX || (ev.clientX + (document.documentElement.scrollLeft || document.body.scrollLeft)),
                y: ev.pageY || (ev.clientY + (document.documentElement.scrollTop  || document.body.scrollTop ))
        };
    }
};
